export const ADD_ON_NAMES = {
  'voice-to-chart': 'Voice to Chart',
  'two-way-texting': 'Two-way Texting',
  'mass-email': 'Mass Email',
  'ai-receptionist': 'AI Receptionist',
} as const;
